module.exports = __webpack_public_path__ + "static/cad-designs10-23a5f6467158013dacb3ed318d6af1d8.png";